import { CONTROL_VIEW_PERMISSION } from '../../constants';
import { api } from '../../jcs';
import HttpService from '../../services/http.service';

export async function hasControlViewPermission($http: HttpService): Promise<boolean> {
  try {
    const { data: permissions } = await $http.get(`${api.url}/users/me/permissions`, { withCredentials: true });
    return Array.isArray(permissions) && permissions.includes(CONTROL_VIEW_PERMISSION);
  } catch (e) {
    console.error(e);
    return false;
  }
}
